import React from 'react';
import './Skills.css';

const SKILL_GROUPS = [
  {
    title: 'AI and Learning',
    items: ['Machine Learning', 'Deep Reinforcement Learning', 'Computer Vision', 'Digital Twins'],
  },
  {
    title: 'Networking and Systems',
    items: ['5G / 6G Communication', 'Congestion Control', 'Real-Time Communication', 'Encrypted Traffic Analysis'],
  },
  {
    title: 'Autonomy and CPS',
    items: ['ROS', 'Autoware', 'Sensor Integration', 'UAV and Vehicle Platforms'],
  },
  {
    title: 'Programming and Tooling',
    items: ['Python', 'C++', 'JavaScript', 'Git', 'Conda', 'Jira', 'Confluence'],
  },
  {
    title: 'Platforms',
    items: ['Linux', 'NVIDIA Jetson Orin Nano', 'Raspberry Pi', 'Embedded Systems'],
  },
  {
    title: 'Applied Domains',
    items: ['Autonomous Systems', 'Cyber-Physical Systems', 'Intelligent Infrastructure', 'IoT'],
  },
];

export default function Skills() {
  return (
    <section id="skills" className="site-section" aria-labelledby="skills-heading">
      <div className="site-section-inner skills-shell">
        <div className="section-heading">
          <p className="section-kicker">Skills</p>
          <h2 id="skills-heading" className="section-title">Technical Stack and Research Capabilities</h2>
          <p className="section-intro">
            A systems-oriented toolkit spanning learning, networking,
            autonomous platforms, and real-world implementation.
          </p>
        </div>

        <div className="skills-grid">
          {SKILL_GROUPS.map((group) => (
            <article key={group.title} className="skills-card card-surface">
              <h3>{group.title}</h3>
              <div className="tag-list">
                {group.items.map((item) => (
                  <span key={item} className="tag-pill">{item}</span>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
